__turbopack_context__.v({
  "chevron": "LinksGroup-module__T9Qq7a__chevron",
  "control": "LinksGroup-module__T9Qq7a__control",
  "link": "LinksGroup-module__T9Qq7a__link",
  "link2": "LinksGroup-module__T9Qq7a__link2",
});
